import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';

import { DateRange, Statistics } from '../models';

export enum SmsActionTypes {
  GetStatisticsOverview = '[SMS Statistics] Get Statistics Overview',
  GetStatisticsOverviewSuccess = '[SMS Statistics] Get Statistics Overview Success',
  GetStatisticsOverviewFail = '[SMS Statistics] Get Statistics Overview Fail',

  GetCountryCodes = '[SMS Statistics] Get Country Codes',
  GetCountryCodesSuccess = '[SMS Statistics] Get Country Codes Success',
  GetCountryCodesFail = '[SMS Statistics] Get Country Codes Fail',

  GetTotalTimeline = '[SMS Statistics] Get Total Timeline',
  GetTotalTimelineSuccess = '[SMS Statistics] Get Total Timeline Success',
  GetTotalTimelineFail = '[SMS Statistics] Get Total Timeline Fail',
}

export class GetStatisticsOverview implements Action {
  readonly type = SmsActionTypes.GetStatisticsOverview;
  constructor(public payload: { dateRange: DateRange; accountId: string }) {}
}

export class GetStatisticsOverviewSuccess implements Action {
  readonly type = SmsActionTypes.GetStatisticsOverviewSuccess;
  constructor(public payload: Statistics) {}
}

export class GetStatisticsOverviewFail implements Action {
  readonly type = SmsActionTypes.GetStatisticsOverviewFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetCountryCodes implements Action {
  readonly type = SmsActionTypes.GetCountryCodes;
  constructor(public payload: { dateRange: DateRange; accountId: string }) {}
}

export class GetCountryCodesSuccess implements Action {
  readonly type = SmsActionTypes.GetCountryCodesSuccess;
  constructor(public payload: Statistics[]) {}
}

export class GetCountryCodesFail implements Action {
  readonly type = SmsActionTypes.GetCountryCodesFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetTotalTimeline implements Action {
  readonly type = SmsActionTypes.GetTotalTimeline;
  constructor(public payload: { timeSpans: number[]; accountId: string }) {}
}

export class GetTotalTimelineSuccess implements Action {
  readonly type = SmsActionTypes.GetTotalTimelineSuccess;
  constructor(public payload: Statistics[]) {}
}

export class GetTotalTimelineFail implements Action {
  readonly type = SmsActionTypes.GetTotalTimelineFail;
  constructor(public payload: HttpErrorResponse) {}
}

export type SmsActions =
  | GetStatisticsOverview
  | GetStatisticsOverviewSuccess
  | GetStatisticsOverviewFail
  | GetCountryCodes
  | GetCountryCodesSuccess
  | GetCountryCodesFail
  | GetTotalTimeline
  | GetTotalTimelineSuccess
  | GetTotalTimelineFail;
